import { ApiLocation } from "@incendium/api";
import { Stack } from "@mui/material";
import LocationAccordionItem from "./LocationAccordionItem";

interface LocationsListProps {
  locations: ApiLocation[];
  onEdit?: (location: ApiLocation) => void;
  onDelete?: (location: ApiLocation) => void;
  onSave?: (location: ApiLocation) => Promise<void>;
}

function LocationsList({ locations, onEdit, onDelete, onSave }: LocationsListProps) {
  return (
    <Stack spacing={1}>
      {locations.map((location) => (
        <LocationAccordionItem
          key={location.id}
          location={location}
          onEdit={onEdit}
          onDelete={onDelete}
          onSave={onSave}
        />
      ))}
    </Stack>
  );
}

export default LocationsList;

